import styles from './Accordion.module.scss';

type AccordionProps = {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  expand?: boolean;
};
export const Accordion = ({ title, children, className, expand }: AccordionProps) => (
  <div className={className}>
    <div className={styles['accordion-container-title']}>{title}</div>
    {expand && <div className={styles['accordion-container-content']}>{children}</div>}
  </div>
);
